import React, { Component, Fragment } from "react";

import Card from "../../../components/Card/Card";
import ContentHeader from "../../../components/Content/ContentHeader/ContentHeader";
import Content from "../../../components/Content/ContentPage/Content";
import ProductCategory from "../../../components/ProductEdit/ProductCategory/ProductCategory";
import ProductData from "../../../components/ProductEdit/ProductData/ProductData";
import ProductAttributeData from "../../../components/ProductEdit/ProductAttribute/ProductAttribute";
import ProductImage from "../../../components/ProductEdit/ProductImage/ProductImage";
import ErrorHandler from "../../../components/ErrorHandler/ErrorHandler";
import MessageHandler from "../../../components/MessageHandler/MessageHandler";

import "../Product.css";

class EditProduct extends Component {
  
  constructor(props) {
    super(props);
    this.childProductData = React.createRef();
    this.childProductAttributeData = React.createRef();
    this.childProductImageData = React.createRef();

    this.state = {
      sectionTitleModeCategory: "sec-open", //"disabled" : "sec-open" : "",
      sectionModeCategory: "active", //"failed" : "active" : "passed" : "",
      stepCategoryContainer: false,
      
      sectionTitleModeProduct: "sec-open", 
      sectionModeProduct: "active", 
      stepProductContainer: false,


      sectionTitleModeAttribute: "sec-open",
      sectionModeAttribute: "active",
      stepAttributeContainer: false,
      
      // sectionTitleModeTitle: "disabled",
      // sectionModeTitle: "",
      // stepTitleContainer: true,

      sectionTitleModeImage: "sec-open",
      sectionModeImage: "active",
      stepImageContainer: false,

      error: null,
      showMessage: false,
      tempCategoryData: {},
      
      
      productCode: 0,
      productData: {},
      disadvantages: [],
      advantages: [],
      brand: {},
      division: {},
      types: [],
      categoryData: {},
      productAttributeData: {},
      productImageList: [],

      
      functionButtonsLoading: false,

      completeProduct: false,
    };
  }

  onClickEdit = () => {
    this.childProductData.current.productFormHandler();
    this.childProductAttributeData.current.productAttributeFormHandler();
    this.childProductImageData.current.productImageFormHandler();
    setTimeout(function() { 
        this.postProductHandler(); //After 1 second, set render to true
    }.bind(this), 3000);  
    // console.log(this.state.productImageList);  
  };
  
  componentDidMount() {
    const productCode = this.props.match.params.productCode;
    const graphqlQuery = {
      query: `query FetchSingleProduct($productCode: Int!) {
                productDetail(productCode: $productCode) {
                    category{
                        id
                        code
                        name
                        secondName
                        enName
                        depth
                        path
                        pathName
                        pathEnglishName
                        hasChildren
                        parentName
                    }
                    product {
                        id
                        code
                        status
                        fake
                        model
                        isActive
                        isIranian
                        isDeleted
                        persianTitle
                        englishTitle
                        package_length
                        package_width
                        package_height
                        package_weight
                        description
                        dataTheme
                        length
                        width
                        height
                        weight
                        mainImageUrl
                    }
                    disadvantages{
                        title
                    }
                    advantages{
                        title
                    }
                    brand{
                        code
                        title
                        enTitle
                    }
                    division{
                        code
                        title
                    }
                    types{
                        code
                        title
                    }                    
                    productImages {
                      id
                      imageUrl
                      slot
                    }
                    productAttribute{
                        code
                        title
                        specifications{
                            code
                            title
                            attributeTypeId
                            isRequire
                            unit
                            productAttributes{
                                value
                                attributeTypeId
                                specificationName
                                items{
                                    code
                                    title
                                }
                            }
                        }
                    }
                }
            }
      `,
      variables: {
        productCode: parseInt(productCode)
      }
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + this.props.token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(graphqlQuery)
    })
      .then(res => {
        return res.json();
      })
      .then(resData => {
        if (resData.errors) {
          throw new Error('Fetching product failed!');
        }
        this.setState({
          categoryData: resData.data.productDetail.category,
          productData: resData.data.productDetail.product,
          productCode: resData.data.productDetail.product.code,
          disadvantages: resData.data.productDetail.disadvantages,
          advantages: resData.data.productDetail.advantages,
          brand: resData.data.productDetail.brand,
          division: resData.data.productDetail.division,
          types: resData.data.productDetail.types,
          productImageList: resData.data.productDetail.productImages,
          productAttributeData: resData.data.productDetail.productAttribute,
          productDetailLoading: false,
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  toggleSection = (ID) => {
    if (ID === "1") {
        this.setState({
          sectionTitleModeCategory: this.state.sectionTitleModeCategory === "" ? "sec-open" : "",
          stepCategoryContainer: this.state.stepCategoryContainer === true ? false : true,
        });
    }
    if (ID === "2") {
      this.setState({
        sectionTitleModeProduct: this.state.sectionTitleModeProduct === "" ? "sec-open" : "",
        stepProductContainer: this.state.stepProductContainer === true ? false : true,
      });
    }
    if (ID === "3") {
      this.setState({
        sectionTitleModeAttribute: this.state.sectionTitleModeAttribute === "" ? "sec-open" : "",
        stepAttributeContainer: this.state.stepAttributeContainer === true ? false : true,
      });
    }
    // if (ID === "4") {
    //   this.setState({
    //     sectionTitleModeTitle: this.state.sectionTitleModeTitle === "" ? "sec-open" : "",
    //     stepTitleContainer: this.state.stepTitleContainer === true ? false : true,
    //   });
    // }
    if (ID === "5") {
      this.setState({
        sectionTitleModeImage: this.state.sectionTitleModeImage === "" ? "sec-open" : "",
        stepImageContainer: this.state.stepImageContainer === true ? false : true,
      });
    }
  };

  checkAddProductHandler = (categoryData) => {
    if (Object.keys(this.state.categoryData).length!==0) {
      if (this.state.categoryData.code !== categoryData.code){
        this.setState({ showMessage: true, tempCategoryData: categoryData });
        }
    } else {
      this.activeProductHandler(categoryData);
    }
  }

  onCancelAddProductHandler = () => {
    this.setState({
      showMessage: false,
    });
  };

  onDeleteAttributeHandler = () => {
    this.activeProductHandler(this.state.tempCategoryData);
    this.setState({
      showMessage: false,
    });
  };

  
  activeProductHandler = (categoryData) => {
    this.setState({
      categoryData: categoryData,
      sectionModeCategory: "passed",
      tempCategoryData: {},

      productData: {},
      productAttributeData: {},

      sectionTitleModeProduct: "sec-open",
      sectionModeProduct: "active",
      stepProductContainer: false,

      sectionTitleModeAttribute: "disabled",
      sectionModeAttribute: "",
      stepAttributeContainer: true,

      // sectionTitleModeTitle: "disabled",
      // sectionModeTitle: "",
      // stepTitleContainer: true,

      sectionTitleModeImage: "disabled",
      sectionModeImage: "",
      stepImageContainer: true,
    });
  }

  addProductHandler = (productData) => {
    this.setState({
      productData: productData,
      sectionModeProduct: "passed",

      sectionTitleModeAttribute: "sec-open",
      sectionModeAttribute: "active",
      stepAttributeContainer: false,
    });
  }

  addProductAttributeHandler = (productAttributeData) => {
    this.setState({
      productAttributeData: productAttributeData,
      sectionModeAttribute: "passed",

      sectionTitleModeImage: "sec-open",
      sectionModeImage: "active",
      stepImageContainer: false,
    });
  }
 
  addProductImageHandler = (productImageList) => {
    // console.log(productImageList);
    var flag = true;
    if (productImageList.length==0) {
      flag = false;
    }
    this.setState({
      productImageList: productImageList,     
      completeProduct: flag, 
    });
  }

  postProductHandler = () => {
    // console.log(this.state.productAttributeData);
    // this.setState({
    //   editLoading: true,
    // });
    this.setState({ completeProduct: false });
    
    const graphqlQuery = {
      query: `
        mutation editProduct($productCode: Int!,$categoryCode: Int!,
        $fake: Boolean!,
        $model: String!,
        $isIranian: Boolean!,
        $persianTitle: String!,
        $englishTitle: String!,
        $package_length: Float!,
        $package_width: Float!,
        $package_height: Float!,
        $package_weight: Float!,
        $description: String!,
        $product_length: Float!,
        $product_width: Float!,
        $product_height: Float!,
        $product_weight: Float!,
        $disadvantage: [String],
        $advantage:[String],
        $brand: Int!,
        $division: Int!,
        $type: [Int]!,
        $attributes: [attributeList]!,
        $images: [imageList]!) {
          updateProduct(code: $productCode, ProductInput: {categoryCode: $categoryCode,
        fake:  $fake,
        model:  $model,
        isIranian:  $isIranian,
        persianTitle:  $persianTitle,
        englishTitle:  $englishTitle,
        package_length:  $package_length,
        package_width:  $package_width,
        package_height:  $package_height,
        package_weight:  $package_weight,
        description:  $description,
        product_length:  $product_length,
        product_width:  $product_width,
        product_height:  $product_height,
        product_weight:  $product_weight,
        disadvantage:  $disadvantage,
        advantage:  $advantage,
        brand:  $brand,
        division:  $division,
        type:  $type,
        attributes:  $attributes,
        images: $images}) {
            id
          }
        }
      `,
      variables: {
        categoryCode: this.state.categoryData.code,        
        fake: this.state.productData.productIsFake,
        model: this.state.productData.model,
        isIranian: this.state.productData.selectedOrigin.value==="0",
        persianTitle: this.state.productData.persianTitle,
        englishTitle: this.state.productData.englishTitle,
        package_length: parseFloat(this.state.productData.package_length),
        package_width: parseFloat(this.state.productData.package_width),
        package_height: parseFloat(this.state.productData.package_height),
        package_weight: parseFloat(this.state.productData.package_weight),
        description: this.state.productData.description,
        product_length: parseFloat(this.state.productAttributeData.product_length),
        product_width: parseFloat(this.state.productAttributeData.product_width),
        product_height: parseFloat(this.state.productAttributeData.product_height),
        product_weight: parseFloat(this.state.productAttributeData.product_weight),

        disadvantage: this.state.productData.negetiveValues,
        advantage: this.state.productData.positiveValues,
        
        brand: this.state.productData.selectedBrand.value,
        division: this.state.productData.selectedDivision.value,
        type: this.state.productData.selectedType.map(type => type.value),
        
        attributes: this.state.productAttributeData.productAttributes,
        
        images: this.state.productImageList.map( image => ({ slot: parseInt(image.id), imageId: image.imageId }) ),

        productCode: parseInt(this.state.productCode)
      },
    };   
    
    
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        // console.log(resData);
        if (resData.errors && resData.errors[0].status === 422) {
          throw new Error(
            " خطا در ذخیره اطلاعات محصول!"
          );
        }
        if (resData.errors) {
          throw new Error("خطایی در ذخیره اطلاعات به وجود آمده!");
        }

        this.props.history.replace('/product');
        
        
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: err,
        });
      });


  };
  

  errorHandler = () => {
    this.setState({ error: null });
  };

  catchError = (error) => {
    this.setState({ error: error });
  };


  render() {
    return (
      <Fragment>
        <ErrorHandler error={this.state.error} onHandle={this.errorHandler} />
        <Content>
          <ContentHeader
            headerAction="درج محصول"
            headerDescription="اطلاعات محصول‌تان را در این صفحه وارد کنید"
          />
          <Card>
            <div className="mn-grid__row">
              <div className="mn-grid__col">
                <div className="mn-product-form">
                  <div className="mn-content-accordion">
                    {/* <section id="stepCategoryAccordion" className={[ "mn-content-accordion__row-section", this.state.sectionTitleModeCategory, ].join(" ")} >
                      <h2 className="mn-content-accordion__title" onClick={this.toggleSection.bind(this, "1")} >
                        <div className="mn-content-accordion__title-text">
                          گام اول: انتخاب گروه کالا
                          <span className="mn-content-accordion__guid-line" data-guideline-modal="category_selection" ></span>
                        </div>
                      </h2>
                      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      <div className={[ "mn-content-accordion__content", this.state.stepCategoryContainer && "uk-hidden", ].join(" ")} id="stepCategoryContainer" aria-hidden="true">
                        <div className="mn-card__body mn-card__body--content">
                          <h3 className="mn-form__action-label">
                            برای درج کالای جدید ابتدا گروه کالای خود را انتخاب
                            کنید:
                          </h3>
                          <label for="" className="search-form__action-label">جستجوی گروه کالای شما:</label>
                              <div className="search-form__autocomplete-container">
                                  <div className="search-form__autocomplete js-autosuggest-box">
                                      <input id="searchKeyword" className="c-content-input__origin js-prevent-submit" type="text" placeholder="نام کالا،  دسته بندی و یا کد دسته بندی مورد نظر خود را بنویسید، مثال: گوشی موبایل">
                                  </div>
                              </div> 
                        </div>
                        <div className="mn-card__body mn-card__body--content">
                          <MessageHandler
                            showMessage={this.state.showMessage}
                            onHandle={this.onCancelAddProductHandler}
                            message={
                              "در صورت تغییر گروه کالایی؛ مقداری از اطلاعاتی که در مرحله‌های بعد وارد کرده‌اید، حذف خواهند شد. از انجام این تغییر اطمینان دارید ؟"
                            }
                            onCancelModal={this.onCancelAddProductHandler}
                            onAcceptModal={this.onDeleteAttributeHandler}
                            acceptMessage="بله، مطمئن هستم"
                            cancelMessage="انصراف"
                          />
                          <ProductCategory
                            userId={this.props.userId}
                            token={this.props.token}
                            errorCatcher={this.catchError.bind(this)}
                            productAddCategoryParentHandler={this.checkAddProductHandler.bind( this )}
                          />
                        </div>
                      </div>
                      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                      <div className={["mn-content-progress", this.state.sectionModeCategory,].join(" ")} >
                        <span className="mn-content-progress__step"></span>
                      </div>
                      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    </section> */}
                    <section id="stepProductAccordion" className={[ "mn-content-accordion__row-section", this.state.sectionTitleModeProduct, ].join(" ")} >
                      <h2 className="mn-content-accordion__title" onClick={this.toggleSection.bind(this, "2")} >
                        <div className="mn-content-accordion__title-text">
                          گام دوم: درج اطلاعات کالا
                          <span className="mn-content-accordion__guid-line" data-guideline-modal="category_selection" ></span>
                        </div>
                      </h2>
                      <div className={[ "mn-content-accordion__content", this.state.stepProductContainer && "uk-hidden", ].join(" ")} id="stepProductContainer" aria-hidden="true" >
                        <ProductData
                          userId={this.props.userId}
                          token={this.props.token}
                          categoryData={this.state.categoryData}
                          addProductHandler={this.addProductHandler.bind(this)}
                          productData={this.state.productData}
                          disadvantages={this.state.disadvantages}
                          advantages={this.state.advantages}
                          brand={this.state.brand}
                          division={this.state.division}
                          types={this.state.types}
                          ref={this.childProductData}
                        />
                      </div>

                      <div className={[ "mn-content-progress", this.state.sectionModeProduct, ].join(" ")}>
                        <span className="mn-content-progress__step"></span>
                      </div>
                    </section>
                    <section
                      id="stepAttributesAccordion"
                      className={[ "mn-content-accordion__row-section", this.state.sectionTitleModeAttribute, ].join(" ")} >
                      <h2 className="mn-content-accordion__title" onClick={this.toggleSection.bind(this, "3")} >
                        <div className="mn-content-accordion__title-text">
                          گام سوم: درج ویژگی‌های کالا
                          <span className="mn-content-accordion__guid-line" data-guideline-modal="category_selection" ></span>
                        </div>
                      </h2>

                      <div className={[ "mn-content-accordion__content", this.state.stepAttributeContainer && "uk-hidden", ].join(" ")} id="stepAttributeContainer" aria-hidden="true" >
                        <ProductAttributeData
                          userId={this.props.userId}
                          token={this.props.token}
                          categoryData={this.state.categoryData}
                          addProductAttributeHandler={this.addProductAttributeHandler.bind( this )}
                          productAttributeData={this.state.productAttributeData}
                          productSize={{"product_length": this.state.productData.length, "product_width": this.state.productData.width, "product_height": this.state.productData.height, "product_weight": this.state.productData.weight }}
                          ref={this.childProductAttributeData}
                        />
                      </div>

                      <div className={[ "mn-content-progress", this.state.sectionModeAttribute, ].join(" ")} >
                        <span className="mn-content-progress__step"></span>
                      </div>
                    </section>
                    {/* <section
                      id="stepTitleAccordion"
                      className={[ "mn-content-accordion__row-section", this.state.sectionTitleModeTitle, ].join(" ")} >
                      <h2 className="mn-content-accordion__title" onClick={this.toggleSection.bind(this, "4")} >
                        <div className="mn-content-accordion__title-text">
                          گام چهارم: عنوان پیشنهادی کالا
                          <span className="mn-content-accordion__guid-line" data-guideline-modal="category_selection" ></span>
                        </div>
                      </h2>

                      <div className={[ "mn-content-accordion__content", this.state.stepTitleContainer && "uk-hidden", ].join(" ")} id="stepTitleContainer" aria-hidden="true" >
                        <ProductData
                          userId={this.props.userId}
                          token={this.props.token}
                          categoryData={this.state.categoryData}
                        /> 
                      </div>

                      <div className={[ "mn-content-progress", this.state.sectionModeTitle, ].join(" ")} >
                        <span className="mn-content-progress__step"></span>
                      </div>
                    </section>  */}
                    <section id="stepImagesAccordion" className={[ "mn-content-accordion__row-section", this.state.sectionTitleModeImage, ].join(" ")} >
                      <h2 className="mn-content-accordion__title" onClick={this.toggleSection.bind(this, "5")} >
                        <div className="mn-content-accordion__title-text">
                          گام پنجم: بارگذاری تصاویر
                          <span className="mn-content-accordion__guid-line" data-guideline-modal="category_selection" ></span>
                        </div>
                      </h2>

                      <div className={[ "mn-content-accordion__content c-content-accordion__content--last", this.state.stepImageContainer && "uk-hidden", ].join(" ")} id="stepImageContainer" aria-hidden="true" >
                        <ProductImage
                            userId={this.props.userId}
                            token={this.props.token}
                            addProductImageHandler={this.addProductImageHandler.bind( this )}
                            productImageList={this.state.productImageList}
                            // categoryData={this.state.categoryData}
                            ref={this.childProductImageData}
                        />
                      </div>

                      <div className={[ "mn-content-progress mn-content-progress--last", this.state.sectionModeImage, ].join(" ")} >
                        <span className="mn-content-progress__step"></span>
                      </div>
                    </section>
                  </div>
                  <form onSubmit={e => { e.preventDefault(); }}>
                    <div className="mn-card__footer mn-card__footer--products">
                      <div className="mn-grid__row">
                        <div className="mn-grid__col mn-grid__col--flex-initial">
                          <div className="uk-flex uk-flex-left">
                            <button 
                              type="button" 
                              className="mn-ui-btn mn-ui-btn--next mn-left"
                              id="saveButton"
                              onClick={this.onClickEdit.bind(this)}>
                              ویرایش کالا
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </Card>
        </Content>
      </Fragment>
    );
  }
}
export default EditProduct;
